module.exports = __webpack_public_path__ + "static/media/Roboto.6f65452a.png";